import { useEffect, useState } from 'react';
import { Dimmer, Divider, Grid, Loader } from 'semantic-ui-react';
import '../../Common/Layout.css';
import { useStitchAuth } from '../../StitchAuth';
import { useStitchMembers } from '../../StitchMembers';
import DeviceAssignmentTopSection from './DeviceAssignmentTopSection';
import { fetchDevices, getMembers } from './DeviceAssignmentUtils';
import DevicesListTable from './DevicesListTable/DevicesListTable';

export default function DeviceAssignment(props) {
  const {
    userCustomData,
  } = useStitchAuth();
  const {actions} = useStitchMembers();
  const [loading, setLoading] = useState(true);
  const [devices, setDevices] = useState();
  const [ownerMap, setOwnerMap] = useState({});
  const [stats, setStats] = useState([]);
  const [memberList, setMemberList] = useState();
  const [sortParam, setSortParam] = useState('lastUsedDesc');

  useEffect(() => {
    let isMounted = true;
    const deviceMap = {
      BT004: 'Weight Scale',
      BT105: 'BP Cuff',
      SMIG: 'Glucometer',
    };

    if (userCustomData) {
      fetchDevices(
        userCustomData.superUserAccess || false,
        userCustomData,
        deviceMap,
        isMounted,
        setOwnerMap,
        setDevices,
        setStats,
      );
      getMembers(
        isMounted,
        setMemberList,
        actions
      );
    }
    return () => {
      isMounted = false;
    };
  }, [userCustomData, actions]);

  useEffect(() => {
    if (devices && memberList) {
      setLoading(false);
    }
  }, [devices, memberList]);

  if (loading) {
    return (
      <div className="messages box">
        <Dimmer active inverted>
          <Loader inverted>Loading</Loader>
        </Dimmer>
      </div>
    );
  } else {
    return (
      <div className="messages box">
        <Grid style={{ margin: 0, padding: 0 }}>
          <DeviceAssignmentTopSection
            devices={devices}
            stats={stats}
          />
          {devices.length > 0 && (
            <Grid.Row columns={1} style={{ padding: 0 }}>
              <Grid.Column>
                <Divider />
                <DevicesListTable
                  devices={devices}
                  setDevices={setDevices}
                  sortParam={sortParam}
                  setSortParam={setSortParam}
                  memberList={memberList}
                  ownerMap={ownerMap}
                  setOwnerMap={setOwnerMap}
                  setLoading={setLoading}
                />
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </div>
    );
  }
}
